<template>
  <div class="alchemy p-1">
    <div>
      <HeaderBar3 :preferred="preferred" :loading="loading" :showSections="false"
        @setSection_in="setSection_out($event)" :ref="hbref"></HeaderBar3>
    </div>



    <div>

      <!-- Customer Area - Sigma-CATO -->
      <Sigma v-if="raw_customer === 'sigma'" :site="site" :sections="sections" style=" margin-top: 92px;" />
      <!-- Customer Area - Banco del Bajío - PALO ALTO -->
      <BanBajio v-if="raw_customer === 'banco_del_bajio'" :site="site" :sections="sections"
        style=" margin-top: 92px;" />
      <!-- Customer Area - Stage - FORTIGATE -->
      <Stage v-if="raw_customer === 'stage'" :site="site" :sections="sections" style=" margin-top: 92px;" />

    </div>

  </div>

</template>

<script>
  // @ is an alias to /src
  import HeaderBar3 from '@/components/HeaderBar3.vue'

  // import Sigma from '@/components/apps-components/integrations/customers/sigma/Main.vue'

  import axios from "axios";

  export default {
    name: 'Integrations',
    components: {
      HeaderBar3,
      Sigma: () => import('@/components/apps-components/integrations/customers/sigma/Main.vue'),
      BanBajio: () => import('@/components/apps-components/integrations/customers/banco_del_bajio/Main.vue'),
      Stage: () => import('@/components/apps-components/integrations/customers/stage/Main.vue')
    },
    data() {
      return {
        site: null,
        service_mode: null, // PV | PB
        stage: null,        // D  | P
        customer: null,     // Solve
        loading: false,
        raw_customer: null,
        // View
        view: 'integrations',
        hbref: 'hb_integrations',
        section: null,
        preferred: 'main',
        sections: [],
        apps: {},

        // Component keys (customers)
        compkeys: {
          sigma: 0,
        },
        // Specific
        selected_section: null,
      }
    },
    methods: {
      solve() {
        this.loading = true
        const params = { view: this.view }
        const dest = this.site + '/suite/main/dnsuite'
        axios
          .get(dest, { params })
          .then(rx => {
            this.customer = rx.data.customer
            this.username = rx.data.username
            this.apps = rx.data.apps
            this.sections = rx.data.sections
            this.$refs[this.hbref].init(this.view, this.username, this.customer, this.sections, this.apps)
            this.loading = false
            this.raw_customer = rx.data.customer.toLowerCase()
          })
          .catch(error => {
            console.log(error)
            this.loading = false
            //this.processErrorMessage(error)
          });
      },
      setSection_out(entry) {
        this.section = entry
      },
      setCustomerSection(_section) {
        // Code
      },
      titlelize(_string) {
        return _string.toLowerCase()
          .split('-')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join('-');
      }
    },
    created: function () {
      this.stage = process.env.NODE_ENV
      this.service_mode = process.env.VUE_APP_SERVICE_MODE
      if (this.stage == 'development') {
        this.site = process.env.VUE_APP_SERVICE_URL
      }
      else {
        this.site = `${window.location.protocol}//${window.location.host}/kraken`
      }
      this.solve()
    }
  }
</script>

<style scoped>
  .section-button {
    background-color: Black;
    border: solid 2px Black;
    color: White;
  }

  .section-button:hover {
    color: rgb(72, 167, 238);
    border-bottom: solid 2px rgb(162, 200, 250);
  }
</style>
